/**
 * Pendant zu `recs.First()` in `Recalc`/`Clone`/`Divide`: Der Altclient wirft bei leerer
 * Auswahl eine `InvalidOperationException`, die der umgebende `catch`-Zweig in eine Meldung
 * überführt. Die Ausnahme bleibt deshalb erhalten.
 */

export function firstSelected<T>(records: T[]): T {
  const first = records[0];
  if (first === undefined) throw new Error('Sequence contains no elements');
  return first;
}

export default firstSelected;
